<script>
/**
 * O comando escolhido no composer como CHIP — módulo (`CRM`) ou atalho
 * (`/panorama`) — e a mesma marca na bolha do usuário.
 *
 * Um componente só para as duas superfícies: o composer e a bolha precisam ler
 * como a mesma coisa. Só o texto, na cor da marca (sem ícone), sem preenchimento no
 * composer (etiqueta dentro da caixa); `com-fundo` dá o tint sutil da bolha,
 * que já tem fundo neutro próprio. O posicionamento no composer é do host.
 */
export default {
  name: 'ComandoChip',
  props: {
    rotulo: {
      type: String,
      required: true,
    },
    comFundo: {
      type: Boolean,
      default: false,
    },
    /** A seleção do campo cobre o texto inteiro: o chip entra na cópia, e mostra. */
    selecionado: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    // Pílula na bolha: não há `--radius-*` desse tamanho, a classe `rounded-circular` do DS cobre.
    classes() {
      return {
        'comando-chip--com-fundo rounded-circular': this.comFundo,
        'comando-chip--selecionado': this.selecionado,
      }
    },
  },
}
</script>

<template>
  <span
    class="comando-chip ia-texto-corpo"
    :class="classes"
    data-teste="comando-chip"
  >
    <span class="comando-chip__nome" data-teste="comando-chip-nome">{{ rotulo }}</span>
  </span>
</template>

<style lang="sass" scoped>
.comando-chip
  display: inline-flex
  align-items: center
  flex-shrink: 0
  min-width: 0
  padding: 0 2px
  color: var(--primary)
  // O passo de 14px vem de `design/_ia-texto.sass` (classe no template).
  line-height: 1.4
  vertical-align: middle

// Na bolha: o tint da marca separa o comando do argumento que vem depois.
.comando-chip--com-fundo
  padding: 2px 8px
  background: color-mix(in srgb, var(--primary) 6%, var(--white))

.comando-chip--selecionado
  border-radius: var(--radius-sm)
  background: color-mix(in srgb, var(--primary) 20%, transparent)

.comando-chip__nome
  overflow: hidden
  text-overflow: ellipsis
  white-space: nowrap
</style>
